import { Typography } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { ProjectTemplateSpace } from 'data/templates/projects';
import { EditSpace } from './edit-space';

export const GroupTitle = styled(Typography.Text)`
  ${BodyShort01};
  color: var(--gray-80);
  width: calc(100% - var(--spacing-05));
  max-width: 166px;
`;

export const MenuTitleContainer = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .add-button,
  .more-actions {
    opacity: 0;
    transition: opacity 50ms ease-in;
  }
  .add-button:focus-within,
  .more-actions:focus-within {
    opacity: 1;
    background-color: var(--coolest-gray-10);
  }

  &:hover {
    .add-button,
    .more-actions {
      opacity: 1;
      background-color: var(--coolest-gray-10);
    }
  }
`;

const MoreActionButton = styled.div`
  position: absolute;
  right: var(--spacing-04);
`;

type TitleContainerTypes = {
  spaceName: string;
  spaceId: number;
  isEdit: boolean;
  isLoading?: boolean | undefined;
  moreActions: ReactNode;
  space: ProjectTemplateSpace;
  dataCy: string;
  onChange: (name: string) => void;
  onCancel: () => void;
};
export const TitleContainer: FC<TitleContainerTypes> = ({
  spaceName,
  isEdit,
  isLoading,
  moreActions,
  space,
  dataCy,
  onChange,
  onCancel,
}) => {
  return (
    <MenuTitleContainer data-cy={dataCy}>
      {isEdit ? (
        <EditSpace
          spaceId={space.spaceId}
          spaceName={space.spaceName}
          cancelEdit={onCancel}
          onUpdate={onChange}
        />
      ) : (
        <>
          <GroupTitle ellipsis={{ tooltip: true }}>{spaceName}</GroupTitle>
          <MoreActionButton onClick={(e) => e.stopPropagation()}>
            {!isLoading && <>{moreActions}</>}
          </MoreActionButton>
        </>
      )}
    </MenuTitleContainer>
  );
};
